<template>
    <div id="content">
      <popup v-show="hasPopup"
             :popup-type="getPopupType"
             :popup-action="getPopupAction"
             @popup-action="executePopupAction" />

        <div class="inner_white">
          <div class="filter">
            <div class="field_left">
              <search-input input-class="search" v-model="formFields.search"></search-input>
            </div>
            <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
          </div>
          <div class="table_overflow" id="contentBox" data-table-id="registered-mac-address-list">
            <table class="vypis" ref="table_with_action_line" v-show="dataLoaded">
                <thead>
                <tr v-if="entities.length > 0">
                  <th class="no_padding drag_drop"></th>
                  <th class="no_padding checkbox"></th>
                    <sorting-table-title
                            v-for="title in sortingTableTitles"
                            :key="title.id"
                            :column="title.column"
                            :sort="getActiveSort(title.column)"
                            @changeSorting="changeSorting"
                    >{{ title.name }}
                    </sorting-table-title>
                  <th class="no_padding edit"></th>
                </tr>
                </thead>
                <tbody>
                <registered-mac-address-row
                        v-for="registeredMacAddress in entities"
                        :entity="registeredMacAddress"
                        :key="registeredMacAddress.id"
                        @input="select"
                        :selectedEntities="selectedEntities"
                ></registered-mac-address-row>
                <tr v-if="entities.length === 0">
                     <td colspan="8">{{ $gettext('Nebyly nalezeny žádné záznamy.') }}</td>
                </tr>
                </tbody>
            </table>
          </div>
            <list-action-line
                    :entities="entities"
                    :selected-entities="filteredSelectedEntities"
                    :multiple-action-options="multipleActionOptions"
                    table-id="registered-mac-address-list"
                    @select-all="toggleSelectAll"
                    @run-multiple-action="runMultipleAction"
                    :offset="formFields.offset"
                    :limit="formFields.limit"
                    :total-count="totalCount"
                    @limit="setLimit"
                    @offset="setOffset"
                    ref="action_line"
            ></list-action-line>
        </div>
    </div>
</template>

<script>
  import RegisteredMacAddressRow from "@/components/views/registeredMacAddress/RegisteredMacAddressRow"
	import listActions from "@/components/mixins/list-actions"

	export default {
		name: "RegisteredMacAddressList",
    components: {RegisteredMacAddressRow},
		mixins: [listActions],
		data() {
			return {
				moduleName: 'registeredMacAddress',
        sortingTableTitles: [
					{id: 1, name: this.$gettext('Mac adresa'), column: 'sMacAddress'},
					{id: 2, name: this.$gettext('Datum vytvoření'), column: 'sDateCreated'},
        ],
			}
		},
		created(RegisteredMacAddressService) {
			this.entityService = RegisteredMacAddressService
			this.createdInit()
		},
    methods: {
    },
    computed: {
      multipleActionOptions() {
        return [
          {value: 'choose', text: this.$gettext('Vyberte akci')},
          {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')}
        ];
      },
      csvHeaders(){
        return this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles)
      },
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/views/registeredMacAddress/MacAddressList.vue